<template>
  <v-container class="overview-page">
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>settings</v-icon>
          {{ $t('settings/customer:edit.titles.edit') }}
        </h2>
        <DataTablePaginated
            ref="table"
            enabledSearch
            :headers="docuHeaders"
            icon="visibility"
            @clickedButton1="CustomerEditSettings"
            sortBy="name"
            add-btn
            :add-btn-text="$t('settings/customer:edit.add-btn')"
            :addBtnRoute="`/${$store.state.manager.settingsModuleUrl}/customer/edit`"
            @cacheCommit="$store.commit('settings/customer/storeCustomerOverviewSearch', $event)"
            :cachedSearch="$store.state.settings.customer.customerOverviewSearch"
            @updateTableData="updateTable"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CustomerService from "@/modules/core/services/customer-service";
import CountryService from "@/modules/core/services/country-service";
import Utils from "@/modules/core/services/utils";
import DataTablePaginated from "@/modules/core/components/DataTable/DataTablePaginated";

export default {
  name: "CustomerAdminSettings",

  components: {
    DataTablePaginated
  },
  data() {
    return {
      // V-model vars
      restCustomer: [],
      restCountry: [],
      restProvince: [],
      table: {
        options: [],
        search: []
      }
    }
  },
  methods: {
    translateCountry(customers) {
      for (let i = 0; i < customers.length; i++) {
        let foundCountry = this.restCountry.find(country => country.id === customers[i].country);
        if (foundCountry) {
          this.$set(customers[i], 'translatedCountry', Utils.translateCountry(foundCountry.name))
        }
      }
    },
    getAllCountries() {
      CountryService.readAllFromAPI(
          (res) => {
            this.restCountry = res.data;
            this.translateCountry(this.restCustomer);
          },
          (error) => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:country')}))
            this.$logger.error(error);
          }
      )
    },

    updateTable(options, search) {
      this.table.options = options;
      this.table.search = search;

      if (!search) search = '';

      CustomerService.readAllPaginatedFromAPI(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          (resp) => {
            this.restCustomer = resp.data.content;
            this.translateCountry(resp.data.content)
            this.$refs.table.fillTableData(resp.data)
          },
          (error) => {
            this.$logger.error("Error at CustomerService.readAllFromAPI" + error)
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:customer_plural')}));
          }
      )
    },
    CustomerEditSettings(item) {
      this.$router.push(`/${this.$store.state.manager.settingsModuleUrl}/customer/edit/${item.id}`);
    }
  },
  watch: {
    currentLang() {
      Utils.sleep(500).then(() => {
        this.translateCountry(this.restCustomer);
      });
    }
  },
  computed: {
    currentLang() {
      return this.$store.state.translation.language;
    },
    docuHeaders() {
      return [
        {text: this.$t('common:name'), value: "name"},
        {text: this.$t('common:street'), value: "street"},
        {text: this.$t('common:zip'), value: "zip"},
        {text: this.$t('common:city'), value: "city"},
        {text: this.$t('common:country'), value: "translatedCountry"},
        {text: this.$t('settings/customer:common.contact-name'), value: "contactName"},
        {text: this.$t('settings/customer:common.contact-mail'), value: "contactMail"},
        {text: this.$t('settings/customer:common.contact-phone'), value: "contactPhone"},
        {text: this.$t('common:created_at'), value: 'createdAt'},
        {text: "", value: "controls", width: "190px"},
      ];
    },
  },
  created() {
    this.getAllCountries();
  },
}
</script>


